import Vue from 'vue'

// Helpers for Vuetify
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify, {
  theme: {
    primary: '#81a3a7',
    secondary: '#c2d3da',
    accent: '#282726',
    error: '#c1403d',
    warning: '#d9ac2a',
    info: '#81a3a7',
    success: '#93a806'
  }
})